// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__Zqbb4","hLoading":"style_hLoading__1Ec9E","wave-text":"style_wave-text__3mqZF"};